/**
 * Auth API
 *
 * In development:  requests go to /ngrok-proxy/api/login.php
 *                  CRA dev server (setupProxy.js) forwards them server-to-server.
 *
 * In production:   set REACT_APP_AUTH_BASE_URL to the full backend base URL.
 *
 * Request body:
 *   { hsUserEmail: string, portalId: number, hsUserId: number }
 *
 * Success response:
 *   {
 *     status: "success",
 *     message: "Login successful",
 *     data: {
 *       token:     string,   // JWT
 *       issuedAt:  number,   // Unix seconds
 *       expiresIn: number    // seconds (1800 = 30 min)
 *     }
 *   }
 */

import { setAuthToken } from '../utils/authToken';

const AUTH_BASE =
  process.env.REACT_APP_AUTH_BASE_URL ||
  '/ngrok-proxy/api';

const LOGIN_URL = `${AUTH_BASE}/login.php`;

/**
 * Calls login.php, stores the JWT in sessionStorage, and returns the token data.
 *
 * @param {{ hsUserEmail: string, portalId: number, hsUserId: number }} credentials
 * @returns {Promise<{ token: string, issuedAt: number, expiresIn: number }>}
 * @throws {Error} if the network request fails or the API returns a non-success status
 */
export async function loginUser({ hsUserEmail, portalId, hsUserId }) {
  const res = await fetch(LOGIN_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({ hsUserEmail, portalId, hsUserId }),
  });

  if (!res.ok) {
    throw new Error(`Login failed: HTTP ${res.status}`);
  }

  const json = await res.json();

  if (json.status !== 'success') {
    throw new Error(json.message || 'Login failed');
  }

  const { token, issuedAt, expiresIn } = json.data;

  // Persist for use by analyticsApi
  //setAuthToken(token, expiresIn, issuedAt);

  return { token, issuedAt, expiresIn };
}
